import type React from 'react';
import Text from '@zg-rentals/multibrand-ui/lib/Text';
import Button from '@zg-rentals/multibrand-ui/lib/Button';
import Modal from '@common/components/Modal';
import SpacerRow from '@zg-rentals/multibrand-ui/lib/SpacerRow';
import userPersonas from '@common/constants/userPersonas';
import StringConstants from '@common/constants/StringConstants';
import './index.scss';

declare const window: any;

type Props = {
  tenantFirstName: string;
  onSubmit: (...args: Array<any>) => any;
};

const RolloutModal: React.FC<React.PropsWithChildren<Props>> = ({
  onSubmit,
  tenantFirstName = 'your tenants',
}: Props): React.ReactElement<any, any> | null => (
  <Modal
    persona={userPersonas.LANDLORD}
    header="NEW UPDATES"
    onRequestClose={onSubmit}
    dataAutoTestId="landlord-rollout-modal"
    isWizard
  >
    <SpacerRow>
      <Text type="h3">We&apos;ve simplified our service.</Text>
    </SpacerRow>
    <SpacerRow>
      <Text>
        It&apos;s now simpler for landlords and renters alike to schedule rent payments, using the payment date as a
        reference point.
      </Text>
      <SpacerRow size="sm" />
    </SpacerRow>
    <SpacerRow>
      <Text emphasize>What&apos;s new?</Text>
      <SpacerRow size="sm" />
      <Text className="Landlord-RolloutModal-List">
        <ul>
          <li>
            We&apos;ll encourage renters to send their rent payments on or before your chosen payment date, similar to
            giving you a rent check.
          </li>
          <li>
            Funds will be available in your account 3–5 business days later depending on your bank&apos;s processing
            times, just like depositing a check.
          </li>
        </ul>
      </Text>
    </SpacerRow>
    <SpacerRow>
      <Text>We let {tenantFirstName} know about the changes too.</Text>
    </SpacerRow>
    <SpacerRow size="md">
      <Button type="primary" full onClick={onSubmit}>
        Ok, got it
      </Button>
      <SpacerRow size="sm" />
      <Button
        type="tertiary"
        full
        onClick={() => {
          window.location = StringConstants.LINKS.SUPPORT_PAGE.LANDLORD;
        }}
      >
        Questions? Contact us
      </Button>
    </SpacerRow>
  </Modal>
);
export default RolloutModal;
